import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Heading, Box } from 'roo-ui/components';
import TextButton from 'components/TextButton';
import Modal from 'components/Modal';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';
import FacilitiesList from 'components/FacilitiesList';
import Markup from 'components/Markup';

const RoomTypeDetails = ({ roomType }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const { name, description, roomTypeFacilities: roomFacilities } = roomType;

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Summary View', value: 'Room Details Selected' });
  }, [emitInteractionEvent, openModal]);

  return (
    <Fragment>
      <TextButton
        onClick={handleOnClick}
        color="greys.charcoal"
        hoverColor="greys.steel"
        fontSize={['sm', 'base']}
        data-testid="room-name"
        fontWeight="bold"
        textAlign="left"
        lineHeight="normal"
      >
        {name}
      </TextButton>

      <Modal {...modalProps} title="Room details">
        <Text display="block" mb="5">
          <Heading.h4 fontSize="sm" mb={4} data-testid="modal-room-name">
            {roomType.name}
          </Heading.h4>
          <Box data-testid="modal-room-description">
            <Markup content={description} />
          </Box>
          <Heading.h4 fontSize="sm" mb={4} mt={4}>
            Room facilities
          </Heading.h4>
          <FacilitiesList facilities={roomFacilities} />
        </Text>
      </Modal>
    </Fragment>
  );
};

RoomTypeDetails.propTypes = {
  roomType: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    roomTypeFacilities: PropTypes.array,
  }).isRequired,
};

export default RoomTypeDetails;
